module.exports = __webpack_public_path__ + "static/pokoj-88929cadeb52f4cb5ffeece7e1f25da5.jpg";